module.exports = __webpack_public_path__ + "img/scroll_default.07488108.svg";